<template>
  <v-card height="100%">
    <v-card-title class="py-2 font-weight-black">Orden</v-card-title>
    <v-row dense>
      <v-col cols="12">
        <show-field
            v-if="order.number"
            :value="order.number.toString()"
            label="Número"
            icon="tag"
        />

      </v-col>
      <v-col cols="12">
        <show-field
            v-if="order.state"
            :value="$t('delivery.states.'+order.state)"
            label="Estado"
            :icon="getIcon"
        />
      </v-col>
      <v-col cols="12">

        <v-card-text class="text-center pb-0  align-self-center">
          <order-progress :order="order"></order-progress>
          <v-alert v-if="!loading" dense text :icon="false" type="info" class="mt-2">
            {{ getStateMessage(order.state) }}
          </v-alert>
        </v-card-text>
      </v-col>
    </v-row>


  </v-card>
</template>

<script>
import {ShowField} from "@dracul/common-frontend"
import OrderStateProvider from "@/modules/delivery/providers/OrderStateProvider";
import OrderProgress from "@/modules/delivery/components-core/shared/OrderProgress/OrderProgress.vue";

export default {
  name: "ShowOrderState",
  components: {OrderProgress, ShowField},
  props: {
    order: {type: Object},
  },
  data() {
    return {
      loading: false,
      states: []
    }
  },
  created() {
    this.fetchMessageStates()
  },
  methods: {
    fetchMessageStates() {
      this.loading = true
      OrderStateProvider.fetchOrderState()
          .then(r => {
            this.states = r.data.fetchOrderState
          })
          .finally(() => this.loading = false)
    }
  },
  computed: {
    getStateMessage() {
      return stateName => {
        let state = this.states.find(i => i.state === stateName)
        if (state) {
          return this.order.delivery.mode === "TAKE_AWAY" ? state.takeAwayMessage : state.deliveryMessage
        } else {
          return this.$t('delivery.statesDescription.' + stateName)
        }
      }
    },
    getIcon() {
      switch (this.order.state) {
        case 'PENDING_RECEIPT':
          return 'receipt'
        case 'NEW':
          return 'pending_actions'
        case 'PREPARING':
          return 'outdoor_grill'
        case 'READY':
          return 'new_releases'
        case 'ON_THE_WAY':
          return 'delivery_dining'
        case 'DELIVERED':
          return 'task_alt'
        default:
          return 'grid_view'
      }
    }
  }
}
</script>

<style scoped>

</style>
